import { Directive, Input, TemplateRef } from '@angular/core';

export interface RowContext<R> {
	$implicit: R;
	row: R;
}

@Directive({
	selector: '[appRowColumn]',
	standalone: true,
})
export class RowColumn<R = unknown> {
	@Input('appRowColumn') key!: string;

	/**
	 * TYPE-INFERENCE ONLY — never read at runtime.
	 * This is what lets the generic R flow correctly in projected templates.
	 */
	@Input() rowType?: R;

	constructor(public template: TemplateRef<RowContext<R>>) {}

	static ngTemplateContextGuard<R>(dir: RowColumn<R>, ctx: unknown): ctx is RowContext<R> {
		return true;
	}
}
